import React from 'react';
import PropTypes from 'prop-types';
// import { Modal } from 'react-bootstrap';
import { I18n as I } from 'react-redux-i18n';

import { DatePicker } from 'antd';
import 'antd/dist/antd.css';

import Modal from 'antd/lib/modal';
import Overview from './Overview';
import Result from 'antd/lib/result';
import Progress from 'antd/lib/progress';
import List from 'antd/lib/list';
import Card from 'antd/lib/card';
import Avatar from 'antd/lib/avatar';
import Col from 'antd/lib/col';

import moment from 'moment';
import 'moment/locale/el';

import { FieldInfo, ControlTypes, bind, isFunc, isNil, Dropdown } from 'vdlib';

const { RangePicker } = DatePicker;
const dateFormat = 'DD-MM-YYYY';

class UpdateEstimationsResultsModal extends React.Component {
  constructor(props) {
    super(props);

    bind(this, ['onHide', 'populate']);

    moment.locale('gr');
    this.populate(props);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(prevProps) {
    this.populate(prevProps);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onHide() {
    if (isFunc(this.props.onHide)) {
      this.props.onHide();
    }
  }

  populate(props) {
    if (isNil(props)) props = this.props;
  }

  render() {
    const { data, error, totalEstimations, insurances } = this.props;

    return (
      <Modal
        className="form-horizontal"
        title={`ΣΥΝΟΛΟ ΣΗΜΕΡΙΝΩΝ ΕΚΤΙΜΗΣΕΩΝ - ${totalEstimations || 0}`}
        visible={this.props.show}
        onOk={this.props.onHide}
        onCancel={this.props.onHide}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={'calc(100vw - 200px)'}
      >
        <Overview
          data={data}
          loading={this.props.submitting}
          insurances={insurances}
          error={error}
          totalEstimations={totalEstimations}
          date={
            data && data.LastProcessingDate
              ? moment(data.LastProcessingDate).format('DD-MM-YYYY')
              : ''
          }
        />
      </Modal>
    );
  }
}

UpdateEstimationsResultsModal.propTypes = {
  onCancel: PropTypes.func,
  onHide: PropTypes.func,
  insurances: PropTypes.array,
  show: PropTypes.bool,
};

export default UpdateEstimationsResultsModal;
